// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding, SmSpacing } from '@alto/design-system';
import React from 'react';

type Props = {
  offerDescription: string;
  offerDetails: string;
};

const DESCRIPTION =
  'The $0* copay offer is available for eligible commercially insured patients only. Terms and conditions apply.';
const DETAILS =
  '*Eligible commercially insurance patients can, for one time only, access Nurtec ODT at no cost while benefits are being verified for one prescription fill, with a maximum of 16 tablets total. Insurance coverage must be approved by the payor for patients to continue receiving Nurtec ODT with no out-of-pocket cost. No membership fees. Only available for commercially insured patients. This is not health insurance. Maximum annual benefit of $7,000 applies.';

export const CouponOfferDetails = ({ offerDescription, offerDetails }: Props) => {
  return (
    <ActionSheetV2 title="How it works">
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body fontFamily="bold">{offerDescription || DESCRIPTION}</Body>
        <SmSpacing />
        <Body>{offerDetails || DETAILS}</Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
